<template>
    <div>
        <folder-navigation-actions type="topics"/>
        <topics-by-folder/>
    </div>
</template>

<script>

import TopicsByFolder from './TopicsByFolder'
import Roles from '@/utilities/Roles'
import {mapGetters} from "vuex";
import FolderNavigationActions from "@/components/Folders/FolderNavigationActions";

export default {
    mixins: [Roles],
    components: {
        FolderNavigationActions,
        TopicsByFolder
    },
    methods: {
        async showTopicBuilder() {
            window.Events.$emit('showQueryBuilderModal', {topic: false});
        },
    },
    computed: {
        ...mapGetters({
            currentTopic: 'currentTopic',
        })
    }
}
</script>

<style>
</style>
